import { Dialog as BaseUiDialog } from '@base-ui-components/react/dialog';
import type React from 'react';
import TablerIconX from '~icons/tabler/x';

import type { CommonProps } from '#/ui/utils/types';
import { cn } from '#/utils/classnames';
import IconButton from './icon-button';
import Typography from './typography';

export interface DialogTitleProps extends CommonProps {
  children?: React.ReactNode;
  /**
   * If true, a close button will be rendered.
   * @default false
   */
  closeable?: boolean;
  onClose?: () => void;
}

function DialogTitle({ children, className, closeable = false, onClose }: DialogTitleProps) {
  return (
    <BaseUiDialog.Title
      className={cn(
        'gooey-dialog-title',
        'flex items-center justify-between gap-4 pb-4',
        className
      )}
    >
      <Typography variant='h4' component='div'>
        {children}
      </Typography>
      {(closeable || !onClose) && (
        <BaseUiDialog.Close>
          <IconButton onClick={onClose}>
            <TablerIconX className='size-5' />
          </IconButton>
        </BaseUiDialog.Close>
      )}
    </BaseUiDialog.Title>
  );
}
DialogTitle.displayName = 'GooeyDialogTitle';

export default DialogTitle;
